export default "<m-sphere\n    color=\"purple\"\n    x=\"3\"\n    y=\"2\"\n    z=\"2\"\n></m-sphere>\n";